'use strict';
var env = require('../../environments/environment').environment;
Parse.initialize();
angular
  .module('gestiondecriseApp')
  .factory('customLoader', function ($http, $q, Raven, ReferentialServiceNew, TranslateService) {
    return function (options) {
      const deferred = $q.defer();
      const defaultTranslations = require('../../assets/i18n/locale-' + options.key + '.json');

      ReferentialServiceNew.getTranslations()
        .then(translations => {
          var mergedTranslations = _.merge(defaultTranslations, translations);
          TranslateService.setTranslation(options.key, defaultTranslations);

          //TODO load only login , and after login load all translations
          TranslateService.setTranslation(options.key, translations, true);

          deferred.resolve(mergedTranslations);
        })
        .catch(error => {
          console.warn('TRANSLATE: ', error.toString());
          deferred.resolve(defaultTranslations);
        });

      return deferred.promise;
    };
  })
  .config(function ($translateProvider) {
    $translateProvider.useLoader('customLoader');
    $translateProvider.preferredLanguage('fr_FR');
    $translateProvider.fallbackLanguage('fr_FR');
    $translateProvider.useSanitizeValueStrategy('escapeParameters');
  });
